module.exports = __webpack_public_path__ + "static/media/HOW YOU CAN ADD OR CREATE CHECKLIST TO BE ASSIGNED TO A CASE.4fdd0dab.png";